import React, { useRef } from 'react';
import { ThemeProvider } from '@mui/material';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { theme } from './theme';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import ServicesOverview from './components/sections/ServicesOverview';
import ProductsSolutions from './components/sections/ProductsSolutions';
import Stats from './components/sections/Stats';
import Footer from './components/Footer';
import Contact from './pages/Contact';
import News from './pages/news';
import { Box } from '@mui/material';
import ScrollToTop from './components/ScrollToTop';
import ScrollToTopOnNavigate from './components/ScrollToTopOnNavigate';

// Import About pages
import VisionMission from './pages/about/sections/VisionMission';
import Leadership from './pages/about/sections/Leadership';
import Strategy from './pages/about/sections/Strategy';
import Innovation from './pages/about/sections/Innovation';
import Partners from './pages/about/sections/Partners';
import CorporateResponsibility from './pages/about/sections/CorporateResponsibility';
import Awards from './pages/about/sections/Awards';
import Careers from './pages/about/sections/Careers';
import Legal from './pages/about/sections/Legal';
import Products from './pages/products/Products';
import GeoManager from './pages/products/GeoManager';
import GeoManagerField from './pages/products/GeoManagerField';
import SocialCommunity from './pages/about/sections/SocialCommunity';

// Import Solutions pages
import Solutions from './pages/solutions/Solutions';
import AerialImagery from './pages/solutions/sections/AerialImagery';
import DroneMapping from './pages/solutions/sections/DroneMapping';
import SatelliteImagery from './pages/solutions/sections/SatelliteImagery';
import CadastralSurvey from './pages/solutions/sections/CadastralSurvey';
import GeophysicalSurvey from './pages/solutions/sections/GeophysicalSurvey';
import HydrographicSurvey from './pages/solutions/sections/HydrographicSurvey';
import GeodeticSurvey from './pages/solutions/sections/GeodeticSurvey';
import GISMapping from './pages/solutions/sections/GISMapping';
import Cartography from './pages/solutions/sections/Cartography';
import LIMS from './pages/solutions/sections/LIMS';
import SoftwareDevelopment from './pages/solutions/sections/SoftwareDevelopment';

// Import BlogPostDetail
import BlogPostDetail from './pages/news/sections/BlogPostDetail';

function App() {
  return (
    <ThemeProvider theme={theme}>
      <Router>
        <Box sx={{ position: 'relative' }}>
          <ScrollToTopOnNavigate />
          <Navbar />
          <Routes>
            <Route path="/" element={
              <>
                <Hero />
                <ServicesOverview />
                <ProductsSolutions />
                <Stats />
              </>
            } />
            <Route path="/contact" element={<Contact />} />
            <Route path="/news" element={<News />} />
            <Route path="/news/:slug" element={<BlogPostDetail />} />
            <Route path="/about/vision-mission" element={<VisionMission />} />
            <Route path="/about/leadership" element={<Leadership />} />
            <Route path="/about/strategy" element={<Strategy />} />
            <Route path="/about/innovation" element={<Innovation />} />
            <Route path="/about/partners" element={<Partners />} />
            <Route path="/about/responsibility" element={<CorporateResponsibility />} />
            <Route path="/about/social-community" element={<SocialCommunity />} />
            <Route path="/about/awards" element={<Awards />} />
            <Route path="/about/careers" element={<Careers />} />
            <Route path="/about/legal" element={<Legal />} />
            <Route path="/products" element={<Products />} />
            <Route path="/products/geomanager" element={<GeoManager />} />
            <Route path="/products/geomanager-field" element={<GeoManagerField />} />
            
            {/* Solutions Routes */}
            <Route path="/solutions" element={<Solutions />} />
            <Route path="/solutions/aerial-photography" element={<AerialImagery />} />
            <Route path="/solutions/drone-mapping" element={<DroneMapping />} />
            <Route path="/solutions/satellite-imagery" element={<SatelliteImagery />} />
            <Route path="/solutions/geodetic-survey" element={<GeodeticSurvey />} />
            <Route path="/solutions/hydrographic-survey" element={<HydrographicSurvey />} />
            <Route path="/solutions/geophysical-survey" element={<GeophysicalSurvey />} />
            <Route path="/solutions/cadastral-survey" element={<CadastralSurvey />} />
            <Route path="/solutions/gis-developments" element={<GISMapping />} />
            <Route path="/solutions/cartography" element={<Cartography />} />
            <Route path="/solutions/lims" element={<LIMS />} />
            <Route path="/solutions/software-development" element={<SoftwareDevelopment />} />
          </Routes>
          <Footer />
          <ScrollToTop />
        </Box>
      </Router>
    </ThemeProvider>
  );
}

export default App;
